module.exports = __webpack_public_path__ + "static/banner1-472101422407fe35e666d22d0d9670bc.jpg";